import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[preventRedirectHandler]',
})
export class PreventRedirectHandlerDirective {
  @Input() preventRedirect: boolean;
  @Output() preventRedirectHandlerClick = new EventEmitter<void>();

  @HostListener('click', ['$event']) onClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    const link = target.closest('a');

    if (link && this.preventRedirect) {
      e.preventDefault();
      e.stopPropagation();
      this.preventRedirectHandlerClick.emit();
    }
  }
}
